import React, { useEffect, useContext } from "react";
import { useTranslation } from 'react-i18next';
import useForm from 'react-hook-form';
import moment from "moment";
import ReactTable from "react-table";
import CsvDownloader from 'react-csv-downloader';
import Datetime from "react-datetime";

// @material-ui/core components
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import Close from "@material-ui/icons/Close";
import AddIcon from '@material-ui/icons/Add';
import Checkbox from "@material-ui/core/Checkbox";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import {ValidSelect} from "beaktShared/helpers/validselect";
import Select from 'react-select';
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import {transformValueFloattoFormated, transformValueFormatedtoFloat, MaskMoney, MaskDate, formateDate, convertDate,  validateDate, getLocale, getStringFormatDate} from "beaktShared/helpers/masks";
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from "@material-ui/core/Tooltip";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import Badge from "beaktShared/components/Badge/Badge.js";
import Success from "beaktShared/components/Typography/Success.js";
import Warning from "beaktShared/components/Typography/Warning.js";
import Danger from "beaktShared/components/Typography/Danger.js";
import Info from "beaktShared/components/Typography/Info.js";
import { GerenciaAlertDelete } from "beaktShared/views/Crud/AlertDelete";

// icons
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import MoneyIcon from '@material-ui/icons/Money';
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import AnnouncementIcon from '@material-ui/icons/Announcement';
import Check from "@material-ui/icons/Check";
import Edit from "@material-ui/icons/Edit";
import Assignment from "@material-ui/icons/Assignment";

// Outros components
import SweetAlert from "react-bootstrap-sweetalert";

// services
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple, UsePostApi, UseDeleteApi } from "beaktShared/services/crudeApiService";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import { noCaseSensitive } from "beaktShared/helpers/extras";

const useStyles = makeStyles(styles);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

export default function Despesas() {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const classes = useStyles();     

    const { register, setValue, errors, setError, clearError, getValues, handleSubmit } = useForm({mode: "onChange"});
    
    const [loading, setloading] = React.useState(false);
    const [loadingTable,setloadingTable] = React.useState(false);
    
    const [notification, setNotification] = React.useState({
        show:false,
        color:'info',
        message:''
    });
    const showNotification = (message,color) => { 
        setNotification({
        show:true,
        color:color,
        message:message      
        });
        setTimeout(function() {
        setNotification({show:false});
        }, 6000);       
    };

    const [alert,setalert] = React.useState();
    const showAlert = (message, tipo) => {        
        setalert(<SweetAlert
          error={tipo==='error'?true:false}
          warning={tipo==='warning'?true:false}
          success={tipo==='success'?true:false}
          title={t('label.warning')}
          onConfirm={() => setalert(null)}
        >  
        <div dangerouslySetInnerHTML={{ __html: message}} /> 
        </SweetAlert> );
    };
    
    const [showModal,setshowModal] = React.useState(false);
    
    const [total, settotal] = React.useState(0);
    const [despesas, setdespesas] = React.useState([]);
    const [list, setlist] = React.useState([])
    const monthDiff = (dateFrom, dateTo) => {
        return dateTo.getMonth() - dateFrom.getMonth() + 
        (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
    }
    
    const [estabelecimento, setestabelecimento] = React.useState(null);// ESTABELECIMENTO SELECIONADO
    const [showSelectEstabelecimentos, setshowSelectEstabelecimentos] = React.useState(false);
    const [isLoadingEstabelecimento, setisLoadingEstabelecimento] = React.useState(false);
    const [estabelecimentos, setestabelecimentos] = React.useState([]);//CARREGA TODOS ESTABELECIMENTOS
    const [estabelecimentosSelectFiltro, setestabelecimentosSelectFiltro] = React.useState([]);//CARREGA TODOS ESTABELECIMENTOS
    
        // Constantes TIPO DE Fornecedor
    const [showSelectTipoFornecedor, setshowSelectTipoFornecedor] = React.useState(false);
    const [selectTiposFornecedor, setselectTiposFornecedor] = React.useState([  //ACESSANDO PELO MODULO MATRIZ, TIPOS DE FORNECEDOR SE VAI SER ESTABELECIMENTOS OU OUTRO FORNECEDOR
     {desc: "Estabelecimento", value: 0},
     {desc: "Fornecedor", value: null}]);
     const [TipoFornecedorContaPagar, seTipoFornecedorContaPagar] = React.useState("");

    //Constantes para listar/setar fornecedor
    const [listSelectFornecedor, setlistSelectFornecedor] = React.useState([]);
    const [fornecedor, setfornecedor] = React.useState(0);
    const [showSelectFornecedor, setshowSelectFornecedor] = React.useState(false);
    const [DescricaoFornecedor, setDescricaoFornecedor] = React.useState(null);
    
    const [dtini, setdtini] = React.useState(formateDate(moment(new Date()).add(-7, 'days')));
    const [dtfim, setdtfim] = React.useState(formateDate(moment(new Date())));
    useEffect(() => {  
        setdtini(formateDate(moment(new Date()).add(-30, 'days')));
        setdtfim(formateDate(new Date()));
              
        setTimeout(function(){
            verifyAcess();
        }, 1000)
    }, []);

    const verifyAcess = () =>{          
        if(session.estabelecimentoId === 0) //Acessando tela pelo modulo matriz
        {
            setshowSelectTipoFornecedor(true);             
        }
    }

    const handleTipoFornecedorChange = event => {// Metodo para SELECIONAR O TIPO DO FORNECEDOR para listar as contas a pagar (qaundo o financeiro for acessado pela FRANQUIA)
        let value = event

        if(value.value == 0){
            seTipoFornecedorContaPagar("Estabelecimento")

        }
        else{
            seTipoFornecedorContaPagar("Fornecedor")

        }

    };
    
    
    const handlePesquisar = () => {
        let data = getValues();

        if(data.dtini === "")
        {
            setError("dtini","required", t('label.required'))
            return false;
        }
        else
            clearError("dtini")
        
        if(data.dtfim === "")
        {
            setError("dtfim","required", t('label.required'))
            return false;
        }
        else
            clearError("dtfim")
        
        if (!validateDate(data.dtini)){
            setError("dtini", "invaliddate", t('error_message.invalid_date'))
            return false;
        }        
        else
            clearError("dtini")
        
        if (!validateDate(data.dtfim)) {
            setError("dtfim", "invaliddate", t('error_message.invalid_date'))
            return false;
        }
        else
            clearError("dtfim")

        var dataIniConvertida = convertDate(data.dtini);
        var dataFimConvertida = convertDate(data.dtfim);
        
        if(monthDiff(dataIniConvertida,dataFimConvertida) > 12){            
            showNotification(t('error_message.select_12month'), 'danger')
            return false; 
        }

        let filter = {
            estabelecimentoId: session.estabelecimentoId == 0 ? estabelecimento : session.estabelecimentoId,
            inicio: dataIniConvertida,
            fim: dataFimConvertida,
            lancadopor: (session.estabelecimentoId == 0 ? "Franquia" : "Estabelecimento"),// SE O ESTABELECIMENTOID FOR 0 significa que está acessando pela FRANQUIA, então necessário trazer somente lançamentos da FRANQUIA
            tipofornecedor: TipoFornecedorContaPagar,// SE O ESTABELECIMENTOID FOR 0 significa que está acessando pela FRANQUIA, então necessário trazer somente lançamentos da FRANQUIA
            franquiaId: (session.franquiaId == 0 ? null : session.franquiaId)
        }

        setloadingTable(true);
        UsePostApi("financeiroestabelecimento/listadespesas", filter).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'error')
                setloadingTable(false);
                return false;
            }
            
            setdespesas(result.data);
            
            let newlist = [];            
            result.data.map(m => newlist.push({
                id: m.despesaEstabelecimentoId,
                tipo: "Despesa",
                documento: m.titulo,
                dataVencimento: m.dataDespesa,
                dataDespesa: m.dataDespesa,
                status: "Liquidado",
                valor: m.valorDespesa,                
                observacoes: m.observacoes,  
                quitado: true,
                estabelecimento: m.franquiaId == null ? m.fornecedorId == null ? "Sem fornecedor": m.fornecedor.fantasia        // Regra para identificar se a descrição é de fornecedor ou estabelecimento ou Sem fornecedor
                : m.fornecedorId == null ? (m.estabelecimentoId == null ? "Sem fornecedor":(m.estabelecimento.descricao + (m.estabelecimento.ativo == true ? " [ Ativo]" : " [ Inativo]"))) : m.fornecedor.fantasia,
                estabelecimentoId : m.estabelecimentoId,
                fornecedorId: m.fornecedorId
            }));

            setloadingTable(false);
            loadDataCsv(newlist);

            setlist(newlist);

            let listtotal = result.data.map(m => m.valorDespesa); 
            if (listtotal.length > 0)
                settotal(listtotal.reduce((a,b) => a + b));
            else
                settotal(0);
        });
    }

    // *******************************************************************************
    // ********************************* LOAD LISTA **********************************
    // *******************************************************************************

    const [isLoadingList, setisLoadingList] = React.useState(false);
    // *******************************************************************************
    // ********************************** CABEÇALHO CSV **********************************
    // *******************************************************************************

    const columnsCSV = [
        { displayName: "Fornecedor", id: "estabelecimento" },
        { displayName: "Documento", id: "documento" },
        { displayName: "Descrição", id: "observacoes" },
        { displayName: "Data", id: "dataDespesa" },
        { displayName: "Valor", id: "valor" },
    ];

    // *******************************************************************************
    // ************************** CARREGAR ITENS DO CSV ******************************
    // *******************************************************************************
     
    const [dataCSV,setdataCSV] = React.useState([]);  
    
    const loadDataCsv = (data) =>{
        let dtCsv = [];

        data.map(item =>{
            var obj = {
                estabelecimento: item.estabelecimento,
                documento: item.documento.replace('-','—'),
                observacoes: item.observacoes,
                dataDespesa: formateDate(item.dataDespesa),
                valor: "R$ " + item.valor.toFixed(2).replace('.',',')
            };
            dtCsv.push(obj);
        })

        setdataCSV(dtCsv);
    } 


        // Loading carregar fornecedrores do estabelecimentos na tela e no modal
    const [loadingSelectFornecedor, setloadingSelectFornecedor] = React.useState(false);    
    const LoadSelectFornecedor = () =>{   
        setloadingSelectFornecedor(true);      
        let endPoint = "fornecedores/ativos/byestabelecimento/"+ session.estabelecimentoId;
        UseGetApiSimple(endPoint,0).then(result=>{       
            if(result.status !== 200)
            {                                     
                showNotification(result.message,'danger');
                setloadingSelectFornecedor(false); 
                return false; 
            }              
            setlistSelectFornecedor(result.data);
            setloadingSelectFornecedor(false); 
            return true;                
        });  
    }

    // Loading carregar fornecedrores da franquia na tela e no modal
    const LoadSelectFornecedorFranquia = () =>{   
        setloadingSelectFornecedor(true);      
        let endPoint = "fornecedores/ativos/byfranquia/"+ session.franquiaId;
        UseGetApiSimple(endPoint,0).then(result=>{       
            if(result.status !== 200)
            {                                     
                showNotification(result.message,'danger');
                setloadingSelectFornecedor(false); 
                return false; 
            }              
            setlistSelectFornecedor(result.data);
            setloadingSelectFornecedor(false); 
            return true;                
        });  
    }

    const LoadEstabelecimentos = () => {
        setisLoadingEstabelecimento(true);
        const endPoint = "estabelecimentos/byfranquia/"+session.franquiaId;// TODOS ESTABELECIMENTOS ATIVOS/INATIVO
        UseGetApiSimple(endPoint, 0).then(result => {
        if (result.status !== 200) {
            showNotification(result.message, 'error')
            setisLoadingEstabelecimento(false);
            return false;
        }

        setisLoadingEstabelecimento(false);
        
        let new_result = []
        result.data.forEach(function(x){ 
            x.descricao += x.ativo ? " [ Ativo ]" : " [ Inativo ]";
            new_result.push(x);
        });

        setestabelecimentos(new_result);

        let _filtro = result.data;
        _filtro.push({estabelecimentoId:0, descricao: "Todos"});
        setestabelecimentosSelectFiltro(_filtro);
        return true;
        });
    };

    //handles de estabelecimento e fornecedor
    const handleEstabelecimentoChange = event => {
        let value = event
        setestabelecimento(value);
        setValue("estabelecimento", value);
        if (value !== "")
            clearError("estabelecimento");
    };

    const handleFornecedorChange = (event) => {
        let value = event
        setfornecedor(value);
    }

    //ABRE MODAL DE ADICIONAR NOVA DESPESA
    const [itemEdit, setitemEdit] = React.useState(null);
    const openDialogTitulo = (item) => {  
        setDescricaoFornecedor("")//descrição do fornecedor

        
        setitemEdit(item);               
        setValue("documento", "");
        setValue("valorConta", "");
        setValue("valorPago", "");
        setValue("observacoes", "");                        
                        
        if (item !== null)
        {            
            setTimeout(function(f)
            {                
                setValue("dataDespesa", formateDate(item.dataDespesa));
                setValue("documento", item.documento);
                setValue("valorConta", item.valor);
                setValue("observacoes", item.observacoes);   
                setshowModal(true);                                                       
            }, 500); 
        }
        else{            
            setTimeout(function(f){                
                setValue("dataDespesa", formateDate(new Date()));    
                setshowModal(true);                            
            }, 500);
        }
    
        if(session.estabelecimentoId == 0){ //acessando pela FRANQUIA
            setshowSelectTipoFornecedor(true);
            setshowSelectEstabelecimentos(false);   
        }
        else{
            LoadSelectFornecedor();         
            setshowSelectFornecedor(true);//ACESSANDO PELO ESTABELECIMENTO 
            setshowSelectEstabelecimentos(false);   
        }
    
    }        

        //handles modal adicionar conta
    const showhandleTipoChange = event => {// AO ADICIONAR UMA NOVA CONTA A PAGAR, tem esse Metodo para SELECIONAR O TIPO DA CONTA A PAGAR fornecedor/Estabelecimento (qaundo o financeiro for acessado pela FRANQUIA)
        let value = event

        if(value.value == 0){
            setshowSelectEstabelecimentos(true); //abre o moal para selecionar o estabelecimento, caso seja um novo lançamento
            setshowSelectFornecedor(false); 
            LoadEstabelecimentos(); // carrega os estabelecimentos na hora de lançar umaconta pagar
            setfornecedor(null);

        }
        else{
            setshowSelectEstabelecimentos(false);//abre o moal para selecionar o fornecedor, caso seja um novo lançamento
            setshowSelectFornecedor(true); //habilita o campo que iá caregar os fornecedores
            LoadSelectFornecedorFranquia();         
            setestabelecimento(null);
        }

    };

    const [alertDelete, setAlertDelete] = GerenciaAlertDelete();
    const handleDelete = id =>{                
        UseDeleteApi("financeiroestabelecimento/deletedespesa/",id,session.id).then(result=>{          
            if(result.status !== 200)
            {                                    
                setAlertDelete({statusAlert:2});
                showNotification(result.message,'danger');
                return false; 
            } 

            var listFiltered = list.filter(obj => {
                return obj.id !== id; 
            });
            setlist(listFiltered);
            setAlertDelete({statusAlert:3}); 
            return true;
        });         
    };    
    const showAlertDelete = id =>{
        setAlertDelete({
            statusAlert:1,
            idToDeleteRecieve:id
        }); 
    }  
    useEffect(() => {  
        if(alertDelete.isToDelete)
            handleDelete(alertDelete.idToDeleteSend);          
    }, [alertDelete]);

    const onSubmit = (data, e) => {        

        if (data.documento === ""){
            return setError("documento", "required");               
        }

        if (data.valorConta === ""){
            return setError("valorConta", "required");               
        }                        
        
        if (!validateDate(data.dataDespesa)){
            return setError("dataDespesa", "invaliddate", t('error_message.invalid_date'));
        }
        
        // if(session.estabelecimentoId === 0){
            
        //     if (showSelectEstabelecimentos === true){    //se estiver acessando pela FRANQUIA, valida o campo Estabelecimento ou FORNECEDOR, se estiver acessando pelo estabelecimento só valida fornecedor
        //         if(estabelecimento == null){    
        //             return setError("estabelecimento", "required");
        //         }
        //     }
        //     else{
        //         if (fornecedor == 0){
        //             return setError("fornecedor", "required");
        //         }
        //     }
        // }
        // else{
        //     if (fornecedor == 0){       //SE ACESSAR PELO ESTABELECIMENTO MANTÉM A VALIDAÇÃO PELO FORNECEDOR
        //         return setError("fornecedor", "required");
        //     }
        // }

        var datadespesa_date = convertDate(data.dataDespesa);  

        let endpoint = "financeiroestabelecimento/savedespesa";

        let item = {
            despesaEstabelecimentoId: (itemEdit != null ? itemEdit.id : 0),
            fornecedorId: fornecedor == 0 ? null : fornecedor,
            estabelecimentoId: (session.estabelecimentoId == 0 ? estabelecimento : session.estabelecimentoId),
            dataDespesa: datadespesa_date,
            titulo: data.documento,
            valordespesa: transformValueFormatedtoFloat(data.valorConta),
            usuarioCadastroId: session.id,
            observacoes: data.observacoes,
            lancadopor: (session.estabelecimentoId == 0 ? "Franquia" : "Estabelecimento"),
            franquiaId: (session.franquiaId == 0 ? null : session.franquiaId)
        }
        setloading(true);
        UsePostApi(endpoint,item).then(result=>{      
            setloading(false);      
            if(result.status !== 200 && result.status !== 201)
            {            
                setloading(false);                         
                showAlert(result.message,'danger');
                return false; 
            }
           
            handlePesquisar();
            setshowModal(false);            
            showNotification(t('financial.title_saved'), "success");            
        });
    }

    const handleEditItem = (item) => {
        setitemEdit(item);   

        setshowModal(true);
        
        if (item !== null)
        {           
             //seta o fornecedor da conta
             setfornecedor(item.fornecedorId);
             setestabelecimento(item.estabelecimentoId);
             setDescricaoFornecedor(item.estabelecimento)//descrição do fornecedor

            if(session.estabelecimentoId == 0){ //acessando pela FRANQUIA
                setshowSelectTipoFornecedor(true);
                setshowSelectEstabelecimentos(false);   
            }
            else{
                LoadSelectFornecedor();         
                setshowSelectFornecedor(true);//ACESSANDO PELO ESTABELECIMENTO 
                setshowSelectEstabelecimentos(false);   
            }
            
             console.log(item);
            setTimeout(function(f)
            {                
                setValue("dataDespesa", formateDate(item.dataDespesa));
                setValue("documento", item.documento);
                setValue("valorConta", item.valor);
                setValue("observacoes", item.observacoes);   
                setshowModal(true);                                                       
            }, 500); 
        }

    }
    const columnsProps = [                
        {
            Header: "Fornecedor",
            accessor: "estabelecimento",
                        
        },
        {
            Header: t('stock.document'),
            accessor: "documento",            
        },
        {
            Header: t('stock.description'),
            accessor: "observacoes",            
        },
        {
            Header: "Data Despesa",
            accessor: "dataVencimento",            
            Cell : (props)=>{
                const custom_date =  formateDate(props.value)
                return <span>{custom_date}</span>
            }
        },
        {
            Header: t('label.value'),
            accessor: "valor", 
            Cell : (props)=>{
                return transformValueFloattoFormated(props.value)
            }           
        }        
    ]
    const columnsAcao = [        
    {
        Header: t('label.actions'),
        Cell: row => (
            <div className="actions-right">                              
                <Button
                    justIcon
                    round
                    simple
                    color="success"
                    className="edit"
                    onClick={() => handleEditItem(row.original)}
                >
                <Tooltip title={t('label.to_edit')}  id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                <Edit />
                </Tooltip>
                </Button>
                {" "}
                <Button
                    justIcon
                    round
                    simple
                    color="danger"
                    className="remove" 
                    onClick={() => showAlertDelete(row.original.id)}                        
                >
                <Tooltip title={t('button.delete')}  id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                <Close />
                </Tooltip>
                </Button>{" "}
            </div>
        ),
        sortable: false,
        filterable: false
    }
    ];

    let columns = [...columnsProps,...columnsAcao];    

    return (
        <div style={{width:'100%',padding:'20px',paddingTop:'0px'}}>
            {notification.show &&
                <div><br/>
                <Snackbar
                    place="tr"
                    color={notification.color}
                    message={notification.message}
                    open={notification.show}
                    closeNotification={() => setNotification({show:false})}
                    close
                />
            </div>}
            {alert}
            {loading && 
                <div className="carregandoCmp">
                    <div className="box">
                        <label>{t('label.loading')}...</label>
                        <CircularProgress />
                    </div>
                </div> 
                }

            <GridContainer>                                
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="primary" icon>                            
                            <h4 className={classes.cardIconTitle}>
                            {t('financial.expense')} 
                            </h4>
                        </CardHeader>
                        <CardBody> 
                        <GridContainer>
                        {showSelectTipoFornecedor &&
                                <GridItem xs={12} sm={6} md={3}>                
                                    <FormControl fullWidth>
                                    <label className={errors.estabelecimento ? "select__label select__label_error" : "select__label"}>{t('Tipo Fornecedor')+" *"} </label>
                                    <Select
                                        fullWidth
                                        size="small"
                                        error={errors.estabelecimento ? true:false}
                                        variant="outlined"
                                        inputRef={register({required:t('label.required')})}
                                        isSearchable={true}
                                        // isLoading={selectTiposFornecedor}
                                        name="tipo"
                                        placeholder="Selecione"
                                        options={selectTiposFornecedor}
                                         //value={estabelecimentos.filter(({ estabelecimentoId }) => estabelecimentoId === estabelecimento)}
                                        getOptionLabel={({ desc }) => desc}
                                        getOptionValue={({ value }) => value}
                                        onChange={(value) => handleTipoFornecedorChange(value)}
                                        ref={() => register({ name: "Tipo" })
                                        }
                                    />
                                    {errors.estabelecimento &&
                                    <FormHelperText>
                                        <span className="obg"> {t('label.select_an_establishment')} </span>
                                    </FormHelperText>}
                                    <br/> <br/>                    
                                    </FormControl>
                                </GridItem>}

                            <GridItem xs={12} sm={6} md={2}>
                                <FormControl fullWidth className={classes.formControl}>                                                               
                                        <label className={errors.dtini?"select__label select__label_error":"select__label"}>
                                        {t('label.ini_date')+" *"}  </label>
                                        <Datetime                                    
                                            locale={getLocale()}
                                            dateFormat={getStringFormatDate()}
                                            timeFormat={false}                                    
                                            name="dtini"                                      
                                            defaultValue={dtini}
                                            value={dtini}
                                            onChange={date => { setdtini(date) }}
                                            inputProps={{name:"dtini", ref:register({required: true}) , readOnly:'readonly' }}                                    
                                            className={errors.dtini?"error":""}            
                                        />       
                                        {errors.dtini && <FormHelperText className={classes.labelRootError}>
                                            <span> {errors.dtini.message} </span>                                                                          
                                    </FormHelperText>} 
                                </FormControl>
                            </GridItem>
                            <GridItem xs={12} sm={6} md={2}>
                                <FormControl fullWidth className={classes.formControl}>                                                               
                                        <label className={errors.dtfim?"select__label select__label_error":"select__label"}>
                                            {t('label.end_date')+" *"}  </label>
                                        <Datetime                                    
                                            locale={getLocale()}
                                            dateFormat={getStringFormatDate()}
                                            timeFormat={false}                                    
                                            name="dtfim"                                      
                                            defaultValue={dtfim}
                                            value={dtfim}
                                            onChange={date => { setdtfim(date) }}
                                            inputProps={{name:"dtfim", ref:register({required: true}) , readOnly:'readonly' }}                                    
                                            className={errors.dtfim?"error":""}            
                                        />       
                                        {errors.dtfim && <FormHelperText className={classes.labelRootError}>
                                            <span> {errors.dtfim.message} </span>                                                                          
                                        </FormHelperText>} 
                                    </FormControl>
                            </GridItem>
                            <GridItem xs={12} sm={6} md={2}>
                                <Button  round color="primary"
                                    onClick={() => handlePesquisar()}>
                                    {t('button.search')} 
                                </Button>
                            </GridItem>
                            <GridItem xs={12} sm={6} md={3} style={{textAlign:"right"}}>
                                <Button round color="primary"
                                    onClick={() => openDialogTitulo(null)}>
                                    <AddIcon></AddIcon>{t('label.add')} 
                                </Button>
                            </GridItem>
                        </GridContainer>
                        <GridContainer>                                                                                            
                            <GridItem xs={6} sm={6} md={4} lg={4}>
                                <div className="cardT">
                                    <div>
                                        <Warning>
                                        <h5><b>
                                        {t('label.money_symbol')} Total
                                        </b></h5></Warning>
                                    </div>
                                    <div className="ico">
                                        <MoneyIcon style={{fontSize:'35px'}} />
                                    </div>
                                    <div style={{clear:'both'}}></div>
                                    <label>{transformValueFloattoFormated(total)}</label>
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                                {
                                dataCSV.length > 0 &&

                                    <div>
                                        <div style={{float:'right'}}>
                                        <CsvDownloader
                                        filename="Despesas"
                                        columns={columnsCSV}
                                        datas={dataCSV}
                                        separator={";"}>
                                            <Button  round color="default" size="sm" >CSV</Button> 
                                        </CsvDownloader>
                                        </div><div style={{clear:'both'}}></div>
                                    </div>
                                }   
                                <ReactTable
                                    loading = {loadingTable}
                                    data={list}
                                    columns={columns}
                                    filterable
                                    defaultFilterMethod = {noCaseSensitive}
                                    defaultPageSize={10}
                                    minRows={5}
                                    showPaginationBottom={true}
                                    className="-striped -highlight"
                                    previousText={t('button.previous')}
                                    nextText={t('button.next')}
                                    loadingText={t('label.loading')+"..."}
                                    noDataText={t('information_message.no_records_found')+"!"}
                                    pageText={t('label.page')}
                                    ofText={t('label.of')}
                                    rowsText={t('label.rows')}
                                />
                            </GridItem>                
                        </GridContainer>
                        </CardBody>
                    </Card>
                </GridItem>               
            </GridContainer>             
            <Dialog
                    classes={{ root: classes.center + " " + classes.modalRoot, paper: classes.modal + ' ' + classes.modalMedium }}
                    open={showModal}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={() => setshowModal(false)}
                    aria-labelledby="classic-modal-slide-title"
                    aria-describedby="classic-modal-slide-description"
                    >
                <DialogTitle
                    id="classic-modal-slide-title"
                    disableTypography
                    className={classes.modalHeader}
                    style={{background:'#5c4477'}}
                >
                    <Button
                        justIcon
                        className={classes.modalCloseButton}
                        key="close"
                        aria-label="Close"
                        color="transparent"
                        onClick={() => setshowModal(false)}
                    >
                        <Close className={classes.modalClose} />
                    </Button>
                    <h4 className={classes.modalTitle} style={{color:'white'}}>{t('financial.expense')} </h4>
                </DialogTitle>
                <DialogContent id="classic-modal-slide-description"
                    className={classes.modalBody} 
                >      
                    <form onSubmit={handleSubmit(onSubmit)}>  
                        <br/>                                      
                        <GridContainer>
                        {showSelectTipoFornecedor &&
                                <GridItem xs={12} sm={6} md={4} style={{zIndex:'9999'}}>                
                                    <FormControl fullWidth>
                                    <label className={errors.estabelecimento ? "select__label select__label_error" : "select__label"}>{t('Tipo Fornecedor')} </label>
                                    <Select
                                        fullWidth
                                        size="small"
                                        error={errors.estabelecimento ? true:false}
                                        variant="outlined"
                                        inputRef={register({required:t('label.required')})}
                                        isSearchable={true}
                                        // isLoading={selectTiposFornecedor}
                                        name="tipo"
                                        placeholder="Selecione"
                                        options={selectTiposFornecedor}
                                         //value={estabelecimentos.filter(({ estabelecimentoId }) => estabelecimentoId === estabelecimento)}
                                        getOptionLabel={({ desc }) => desc}
                                        getOptionValue={({ value }) => value}
                                        onChange={(value) => showhandleTipoChange(value)}
                                        ref={() => register({ name: "Tipo" })
                                        }
                                    />
                                    <br/> <br/>                    
                                    </FormControl>
                                </GridItem>}
                                {showSelectEstabelecimentos &&
                                <GridItem xs={12} sm={12} md={12} style={{zIndex:'999'}}>                
                                    <FormControl fullWidth >
                                    <label>{t('label.establishment')+" *"} </label>
                                    <Select
                                        fullWidth
                                        size="small"
                                        // error={errors.estabelecimento ? true:false}
                                        variant="outlined"
                                        // inputRef={register({required:t('label.required')})}
                                        isSearchable={true}
                                        isLoading={isLoadingEstabelecimento}
                                        name="estabelecimento"
                                        placeholder="Selecione..."
                                        options={estabelecimentos}                                        
                                        value={estabelecimentos.filter(({ estabelecimentoId }) => estabelecimentoId === estabelecimento)}
                                        getOptionLabel={({ descricao }) => descricao}
                                        getOptionValue={({ estabelecimentoId }) => estabelecimentoId}
                                        onChange={(value) => handleEstabelecimentoChange(value.estabelecimentoId !== null ? value.estabelecimentoId : "")}
                                        ref={() => register({ name: "estabelecimento" })
                                        }
                                    />
                                    <br/> <br/>                    
                                    </FormControl>
                                </GridItem>}

                                {showSelectFornecedor &&    
                            <GridItem xs={12} sm={12} md={12} style={{zIndex:'999'}}>                                                    
                                <FormControl fullWidth className={classes.formControl}>                                    
                                    <label> 
                                    {t("label.supplier")} </label>
                                    <Select
                                        classNamePrefix="select"
                                        styles={ValidSelect(errors.fornecedor ? true : false)}
                                        isSearchable={true}
                                        isLoading={loadingSelectFornecedor}
                                        name="fornecedor"
                                        placeholder={t('label.select')+"..."}
                                        options={listSelectFornecedor}
                                        value={listSelectFornecedor.filter(({ fornecedorId }) => fornecedorId === fornecedor)}
                                        getOptionLabel={({ fantasia }) => fantasia}
                                        getOptionValue={({ fornecedorId }) => fornecedorId}
                                        onChange={(value) => handleFornecedorChange(value.fornecedorId !== null ? value.fornecedorId : "")}
                                        ref={() => register({ name: "fornecedor" })
                                        }
                                    />
                                </FormControl>
                            </GridItem>}

                            <GridItem xs={12} sm={6} md={4}>                                                    
                                <FormControl fullWidth className={classes.formControl}>                               
                                    <TextField                                        
                                        error={errors.valorConta?true:false}
                                        label={t("financial.bill_amount") + " *"}
                                        variant="outlined"
                                        inputRef={register({required: true})}
                                        name="valorConta"                                            
                                        InputLabelProps={{shrink: true}}
                                        InputProps={{
                                            inputComponent: MaskMoney,                                            
                                        }}                   
                                    />
                                    <FormHelperText className={classes.labelRootError}>
                                        {errors.valorConta && <span>{t('label.required')} </span>}
                                    </FormHelperText>   
                                </FormControl>                                      
                            </GridItem>  
                            <GridItem xs={12} sm={6} md={4}>
                                <FormControl fullWidth className={classes.formControl}>
                                    <TextField
                                        error={errors.documento?true:false}
                                        variant="outlined"
                                        inputRef={register({required: t('label.required')})}
                                        label={t("label.document_number") + " *"}
                                        name="documento"                                            
                                        inputProps={{maxLength: 30}} 
                                        InputLabelProps={{shrink: true}}                                            
                                    />
                                    {errors.documento && 
                                    <FormHelperText>
                                        <span className="obg"> {errors.documento.message }</span>
                                    </FormHelperText>}
                                </FormControl>
                            </GridItem>    
                             <GridItem xs={12} sm={12} md={4}>
                                <FormControl fullWidth className={classes.formControl}>
                                    <TextField
                                        error={errors.dataDespesa?true:false}
                                        variant="outlined"
                                        inputRef={register({required: t('label.required')})}
                                        label={t("financial.expense_date") + " *"}
                                        name="dataDespesa"                                                
                                        InputLabelProps={{shrink: true}}
                                        InputProps={{ inputComponent: MaskDate }}               
                                    />
                                    {errors.dataDespesa && 
                                    <FormHelperText className={classes.labelRootError}>
                                        {errors.dataDespesa && <span className="obg"> {errors.dataDespesa.message }</span>}
                                    </FormHelperText>   
                                    }
                                </FormControl>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <FormControl fullWidth className={classes.formControl}>
                                    <TextField                                            
                                        variant="outlined"
                                        inputRef={register({required: t('label.required')})}
                                        label={t("label.description")}
                                        name="observacoes"                                            
                                        inputProps={{maxLength: 300}} 
                                        InputLabelProps={{shrink: true}}                                            
                                    />                                        
                                </FormControl>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <center>
                                    <br/>
                                    <Button type="submit" color="primary">
                                        {t('button.to_save')} 
                                    </Button>
                                    <br/>
                                </center>
                            </GridItem>
                        </GridContainer>                                                                              
                    </form>                                              
                </DialogContent>
            </Dialog>
            {alertDelete.componente}
        </div>
    );
}